<template>
    <div class="trash">
        <orderCard  v-for="(order,index) in orders" :key="index" :id="order.ID" :order="order" :orderIndex="index" ></orderCard>
    </div>
</template>
<script>
    import { db } from '../firebase';
    import order from '../components/Order.vue';
    import firebase from "firebase/app";
    import moment from 'moment';
    import orderCard from '../components/orderCard.vue';

export default {
  name: 'Trash',
  components:{
    orderCard
  },
  data () {
    return {
        txtSearch:'',
        orders:[]
        
    }
  },
  created(){
    let vm = this;
    vm.loadOrdersFromTrash();
  },
  methods:{
    loadOrdersFromTrash(){
        let vm = this;
        db.collection("orders").where("status", "==", "נמחקה").get().then((result)=>{
            for(let i = 0; i < result.size; i++){
                let order = result.docs[i].data();
                let orderId = result.docs[i].id;
                vm.orders.push({ ID: orderId, Data: order });
            }
           console.log("Success")
        }).catch((error)=>{
            console.log("Error loading Orders >>>", error);
        })
    }
  }

}
</script>

<style>
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.trash{
    padding: 1rem;
    display: flex;
    align-items: normal;
    justify-content: space-between;
    flex-wrap: wrap;
}

</style>


// WEBPACK FOOTER //
// src/pages/Trash.vue